module.exports = __webpack_public_path__ + "img/NW0194324-Lace.af0f26e3.jpg";